<template>
    <div class="group pr-2">
        <input v-bind:type="type" v-bind:name="name" v-model="thisVal" @change="emitGlobalChange()" required/>
        <span class="highlight"></span>
        <span class="bar"></span>
        <label>
            <the-language :de="placeholder_de" :en="placeholder_en" />
        </label>

    </div>
</template>

<script>

    import { serverBus } from '../../main';
    import TheLanguage from "../TheLanguage";

    export default {
        name: 'inputcomponent',
        components: {
            TheLanguage
        },
        props: {
            type: String,
            placeholder_de: String,
            placeholder_en: String,
            name: String,
            value: null
        },
        data() {
            return {
                thisVal: this.thisVal
            }
        },
        methods: {
            emitGlobalChange() {
                serverBus.$emit(this.name, this.thisVal);
            }
        }
    }
</script>


<style lang="scss" scoped>
    .group {
        position: relative;
        margin: 5px 0 10px 0;
    }

    input {
        font-size: 18px;
        padding: 10px 10px 10px 5px;
        display: inline-block;
        width: 100%;
        border: none;
        border-bottom: 1px solid;
        @apply border-primary-orange bg-secondary-grey;
    }

    input:focus {
        outline: none;
    }

    label {
        @apply text-primary-orange;
        font-size: 16px;
        font-weight: normal;
        position: absolute;
        pointer-events: none;
        left: 5px;
        top: 10px;
        transition: 0.2s ease all;
        -moz-transition: 0.2s ease all;
        -webkit-transition: 0.2s ease all;
    }

    /* active state */
    input:focus ~ label,
    input:valid ~ label {
        top: -20px;
        font-size: 14px;
    }

    /* BOTTOM BARS ================================= */
    .bar {
        position: relative;
        display: block;
        width: 100%;
    }

    .bar:before, .bar:after {
        content: '';
        height: 2px;
        width: 0;
        bottom: 1px;
        position: absolute;
        @apply bg-primary-orange;
        transition: 0.2s ease all;
        -moz-transition: 0.2s ease all;
        -webkit-transition: 0.2s ease all;
    }

    .bar:before {
        left: 50%;
    }

    .bar:after {
        right: 50%;
    }

    /* active state */
    input:focus ~ .bar:before, input:focus ~ .bar:after {
        width: 50%;
    }

    /* HIGHLIGHTER ================================== */
    .highlight {
        position: absolute;
        height: 60%;
        width: 100px;
        top: 25%;
        left: 0;
        pointer-events: none;
        opacity: 0.5;
    }

    /* active state */
    input:focus ~ .highlight {
        -webkit-animation: inputHighlighter 0.3s ease;
        -moz-animation: inputHighlighter 0.3s ease;
        animation: inputHighlighter 0.3s ease;
    }

    /* ANIMATIONS ================ */
    @-webkit-keyframes inputHighlighter {
        from {
            background: #5264AE;
        }
        to {
            width: 0;
            background: transparent;
        }
    }

    @-moz-keyframes inputHighlighter {
        from {
            background: #5264AE;
        }
        to {
            width: 0;
            background: transparent;
        }
    }

    @keyframes inputHighlighter {
        from {
            background: #5264AE;
        }
        to {
            width: 0;
            background: transparent;
        }
    }
</style>